import Button from "@mui/material/Button"
import Stack from "@mui/material/Stack"
import { useRecoilState } from "recoil";
import { formInEditModeState } from "../state";
import { useTranslation } from "react-i18next";

function ToolbarActions(props: {
    onSave: () => void,
    onCancel: () => void,
    editDisabled?: boolean,
}) {
    const {t} = useTranslation(['network', 'translation']);
    const [inEditMode, setInEditMode] = useRecoilState(formInEditModeState);

    return (
        <Stack direction="row" columnGap={1} py={1}>
            {inEditMode || <Button disabled={props.editDisabled} onClick={() => setInEditMode(true)}>{t("msHoliday.labels.edit")}</Button>}
            {inEditMode && <Button onClick={props.onCancel}>{t("msHoliday.labels.cancel")}</Button>}
            {inEditMode && <Button onClick={props.onSave}>{t("msHoliday.labels.save")}</Button>}
        </Stack>
    )
}

export default ToolbarActions